export default __webpack_public_path__ + "static/media/comming-soon.2da48477.jpg";